import { Box } from "@mui/material";
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import CallIcon from '@mui/icons-material/Call';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';

import useDisplayDate from "../../hooks/Date/useDisplayDate";


const OrgCreditReportColumns = () => {
  const { formatDate } = useDisplayDate();

  return [
    { accessorKey: 'userName', header: 'User Name',},
    { accessorKey: 'role', header: 'Role',},
      { accessorKey: 'loanAmtApprv', header: 'Loan Amount',size: 200,},
      { accessorKey: 'tled', header: 'No Of Disbursed',size: 200 },
      { accessorKey: 'adfee', header: 'Admin Fees'},
      { accessorKey: 'gsfee', header: 'GST Fees' },
      { accessorKey: 'comp', header: 'Industry',},
      { accessorKey: 'disbursedamt', header: 'Disbursal Amount',size: 250},
      { accessorKey: 'new_case_count', header: 'New Case',size: 250},
      { accessorKey: 'repeat_case_count', header: 'Repeat Case',size: 250},

      

     

  ];
};

export default OrgCreditReportColumns;
